import { atom } from 'jotai'

export const userInfoAtom = atom<{
  id: string
  name?: string
} | null>(null)
